import { useQuery } from '@tanstack/react-query';
import { Server } from '../services/Server';
import { useFieldValue } from './useFormValues';

const isCoordinate = (value: unknown, limit: number) => value !== '' && value !== null && Math.abs(Number(value)) <= limit;

export const hasCoordinates = (latitude: unknown, longitude: unknown) => isCoordinate(latitude, 90) && isCoordinate(longitude, 180);

export const rainRecommendationQueryOptions = <T>(
  latitude: unknown,
  longitude: unknown,
  fetchRecommendation: (location: { latitude: number; longitude: number }) => Promise<T>,
) => ({
  queryKey: ['rain-recommendation', latitude, longitude],
  queryFn: () => fetchRecommendation({ latitude: Number(latitude), longitude: Number(longitude) }),
  staleTime: Infinity,
});

export const useRainRecommendation = () => {
  const latitude = useFieldValue('location.latitude');
  const longitude = useFieldValue('location.longitude');
  const { getRainRecommendationAPI } = Server();

  return useQuery({
    ...rainRecommendationQueryOptions(latitude, longitude, getRainRecommendationAPI),
    enabled: hasCoordinates(latitude, longitude),
  });
};
